export const CONTENT_WIDTH = 248
